"use client";
import Image from "next/image";

const CRHeaderLogo = () => {
  return (
    <a href="/crypto-read" className="hover-img z-10">
      <Image
        className="hover-img pointer-events-none"
        src="/images/cryptoread/logo.svg"
        width={182}
        height={20}
        alt="crypto-read-logo"
      />
    </a>
  );
};

export default CRHeaderLogo;
